var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 251"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape Copy",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0926 4.53589L7.35514 10.537L4.94567 8.01731L3.33936 9.69712L5.74883 12.2168L7.35514 13.8978L8.96257 12.2168L14.6989 6.21569L13.0926 4.53589V4.53589Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval 23 Copy",
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#59B800"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape Copy_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7533 5L7.01579 11.0011L4.60631 8.48142L3 10.1612L5.40947 12.6809L7.01579 14.3619L8.62321 12.6809L14.3596 6.67981L12.7533 5V5Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.80dc410f28d6d7877b6f8a6f6bdf2d40.svg";
export { ForwardRef as ReactComponent };